export default "__VITE_ASSET__C06g$iH2__"